import ky from "ky";
import { showErrorToast } from "@/lib/helpers/errorToast";
import { KY_OPTIONS } from "@/config";
import { loginQuery } from "@/lib/domain/authRedirect";

export const apiClient = ky.create({
  ...KY_OPTIONS,
  hooks: {
    beforeError: [
      async (error) => {
        const status = error.response?.status;
        const locallyHandled = error.options.context.localErrorHandling === true;
        const payload = error.response
          ? await error.response
              .clone()
              .json()
              .catch(() => null)
          : null;
        const message = typeof payload?.message === "string" ? payload.message : undefined;

        if (message) error.message = message;

        if (!locallyHandled && error.response && status && status >= 400 && status !== 401) {
          showErrorToast(status, message);
        }
        if (!locallyHandled && status === 401) {
          const { redirect } = loginQuery(window.location.pathname + window.location.search);
          window.location.href = redirect ? `/login?redirect=${encodeURIComponent(redirect)}` : "/login";
        }
        return error;
      },
    ],
  },
});
